import { Skeleton } from '../../Skeleton'
import * as Styled from './styles'

export const SnackEskeleton = () => {
  return (
    <div className='skeleton-wraper'>
      <Styled.Container>
        <Skeleton type='title' />
        <Skeleton type='thumbnail' />
        <Skeleton type='text' />

        <div>
          <Skeleton type='text' />
          <Skeleton type='image' />
        </div>
      </Styled.Container>
    </div>
  )
}
